export function genFQCN(artist_iindy_id, collection_name, series_name) {
    return `${artist_iindy_id}^${collection_name}^${series_name}`;
}